import React from 'react'
import '../estilos/QuieneSomos.css'
import { useTranslation } from 'react-i18next';

function MissionVision() {
  const { t } = useTranslation();
  return (
    <section className="mission-vision">
      <h2 className="mission-vision-main-title">{t('quienes_mision_vision')}</h2>
      <div className="mission-vision-line"></div>
      <div className="mission-vision-container">

        <div className="mission-vision-card">
          <div className="mission-vision-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <circle cx="12" cy="12" r="6"/>
              <circle cx="12" cy="12" r="2"/>
            </svg>
          </div>
          <h3 className="mission-vision-title">{t('quienes_mision')}</h3>
          <p className="mission-vision-text">{t('mision_texto')}</p>
        </div>

        <div className="mission-vision-card">
          <div className="mission-vision-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/>
              <circle cx="12" cy="12" r="3"/>
            </svg>
          </div>
          <h3 className="mission-vision-title">{t('quienes_vision')}</h3>
         <p className="mission-vision-text">{t('vision_texto')}</p>
        </div>

      </div>
    </section>
  )
}

export default MissionVision
